module.exports = __webpack_public_path__ + "img/FF_Info_Game_13.066f4ee1.png";